/**
 * The home page product film: which cut plays where.
 *
 * Phones held upright get the vertical 1080x1920 cut; everything else gets the
 * landscape 1920x1080 cut. The choice is made once, on the first tap of play,
 * so a visitor only ever downloads one of the two files (and nothing at all
 * until they press play).
 *
 * VERTICAL_CUT_QUERY is repeated in ProductFilm.module.css (the poster box and
 * the <picture> source use it before any JavaScript runs). Keep them in step;
 * product-film.test.ts fails if they drift apart.
 *
 * The files are served from public/films with a one-year immutable cache
 * (next.config.ts), so a new film must ship under a new file name.
 */

export const VERTICAL_CUT_QUERY = "(max-width: 767px) and (orientation: portrait)";

export type FilmCut = "landscape" | "vertical";

export interface FilmSource {
  src: string;
  poster: string;
  width: number;
  height: number;
}

export const FILM_DURATION_LABEL = "0:55";

export const FILM_CUTS: Record<FilmCut, FilmSource> = {
  landscape: {
    src: "/films/ethos-virtual-film-2026-09-landscape.mp4",
    poster: "/films/ethos-virtual-film-2026-09-landscape-poster.jpg",
    width: 1920,
    height: 1080,
  },
  vertical: {
    src: "/films/ethos-virtual-film-2026-09-vertical.mp4",
    poster: "/films/ethos-virtual-film-2026-09-vertical-poster.jpg",
    width: 1080,
    height: 1920,
  },
};

type MatchMedia = (query: string) => { matches: boolean };

/**
 * Pick the cut for this screen. Without matchMedia (very old browsers, tests)
 * or if it throws, fall back to the landscape cut, which plays everywhere.
 */
export function chooseCut(matchMedia?: MatchMedia): FilmCut {
  if (!matchMedia) return "landscape";
  try {
    return matchMedia(VERTICAL_CUT_QUERY).matches ? "vertical" : "landscape";
  } catch {
    return "landscape";
  }
}
